import { RestClient } from '@lounge-fe/network'
import { captureException } from '@sentry/react'
import { UseQueryOptions, useQuery } from '@tanstack/react-query'

const SORT_ORDER = [
  'bra',
  'thongs',
  'apparel',
  'swim-top',
  'swim-bottom',
  'stockings',
  'socks',
  'boxers',
]

export const useSizeGuidesQuery = (
  sizeGuides: string[],
  options: Partial<UseQueryOptions>,
) => {
  return useQuery({
    queryKey: ['sizeGuides', ...sizeGuides],
    queryFn: async () => {
      const http = new RestClient({
        baseURL: '/',
        useCSRF: false,
      })

      const sizeGuidesParam = sizeGuides
        .sort((a, b) => SORT_ORDER.indexOf(a) - SORT_ORDER.indexOf(b))
        .map((sizeGuide) => `size-guide_${sizeGuide}`)
        .join(',')

      const res = await http.get<{ [key: string]: string }>(
        `?sections=${sizeGuidesParam}`,
      )

      const parsedHTML = Object.values(res.data).map((html) =>
        new DOMParser().parseFromString(html, 'text/html'),
      )

      return parsedHTML.map((sizeGuide) => {
        const tbody = sizeGuide.querySelector('table>tbody')
        if (tbody) {
          try {
            // Try and sort the table rows by the data-order attribute
            const newNodes = [...tbody.children].sort(
              (a, b) =>
                Number((a as HTMLElement).dataset.order) -
                Number((b as HTMLElement).dataset.order),
            )

            // Replace the table rows with the sorted ones
            while (tbody.lastChild) {
              tbody.removeChild(tbody.lastChild)
            }
            tbody.append(...newNodes)
          } catch (error) {
            captureException(error)
          }
          tbody.classList.remove('[&_td]:text-transparent')
        }

        return sizeGuide.documentElement.innerHTML
      })
    },
    ...options,
  })
}
